<canvas #chart class="loading-component" [ngClass]="{ 'loading': loading }"></canvas>
<div *ngIf="loading" class="loading-msg-container">
  <span *transloco="let t;">{{ t('app.data-loading') }}</span>
</div>
